import React from 'react';
import { Wrapper } from './AccordionStyles';
import AccordionItem from './fragments/AccordionItem';

const Accordion = ({ children }) => {
  return (
    <Wrapper>
      {React.Children.map(children, child => {
        const { props } = child;
        return <AccordionItem {...props} content={child} />;
      })}
    </Wrapper>
  );
};

export default Accordion;
